import { Button, Label, SecretInput, Spinner } from '@repo/ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { KeyRound } from 'lucide-react'
import { type FormEvent, useEffect, useState } from 'react'
import { toast } from 'sonner'

import { AuthShell } from '@/components/auth/auth-shell'
import { useAuth } from '@/hooks/use-auth'
import { authApi } from '@/lib/api'

export const Route = createFileRoute('/alterar-senha')({
  component: ChangePasswordPage,
})

function ChangePasswordPage() {
  const navigate = useNavigate()
  const { user, loading } = useAuth()
  const [currentPassword, setCurrentPassword] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!loading && !user) {
      void navigate({ to: '/entrar', search: { returnTo: undefined } })
    }
  }, [user, loading, navigate])

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()

    if (password.length < 8) {
      toast.error('A senha deve ter no mínimo 8 caracteres')
      return
    }

    if (password !== confirm) {
      toast.error('As senhas não conferem')
      return
    }

    setSubmitting(true)

    try {
      await authApi.post('/api/auth/change-password', {
        currentPassword,
        newPassword: password,
      })
      toast.success('Senha alterada com sucesso!')
      await navigate({ to: '/inbox' })
    } catch {
      setSubmitting(false)
      return
    }

    setSubmitting(false)
  }

  return (
    <AuthShell
      title="Alterar senha"
      subtitle="Defina uma nova senha para sua conta"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="current">Senha atual</Label>
          <SecretInput
            id="current"
            visibilityLabel="senha atual"
            required
            autoComplete="current-password"
            value={currentPassword}
            onChange={(event) => setCurrentPassword(event.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Nova senha</Label>
          <SecretInput
            id="password"
            visibilityLabel="nova senha"
            required
            autoComplete="new-password"
            placeholder="Mínimo 8 caracteres"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirm">Confirmar nova senha</Label>
          <SecretInput
            id="confirm"
            visibilityLabel="confirmação da nova senha"
            required
            autoComplete="new-password"
            value={confirm}
            onChange={(event) => setConfirm(event.target.value)}
          />
        </div>
        <div className="flex items-center gap-2">
          <KeyRound className="text-muted-foreground h-4 w-4" />
          <span className="text-muted-foreground text-xs">
            A senha deve ter no mínimo 8 caracteres
          </span>
        </div>
        <Button type="submit" className="w-full" disabled={submitting}>
          {submitting ? <Spinner /> : null}
          Alterar senha
        </Button>
      </form>
    </AuthShell>
  )
}
